<div id="layout-wrapper">

  <app-sidebar [isCondensed]="isCondensed" (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-sidebar>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->

    <app-footer></app-footer>

  </div>
</div>
